import { defineComponent as o, openBlock as r, createBlock as a, normalizeProps as n, guardReactiveProps as l, withCtx as p, renderSlot as s, createElementVNode as c } from "vue";
import d from "../CdrIcon.vue.mjs";
const m = /* @__PURE__ */ c("path", {
  role: "presentation",
  d: "M13.415 12.006l5.295-5.292a1 1 0 00-1.414-1.415L12 10.591 6.71 5.296A1 1 0 005.295 6.71l5.292 5.295-5.295 5.292a1 1 0 101.414 1.414l5.295-5.292 5.292 5.295a1 1 0 001.414-1.414l-5.292-5.294z"
}, null, -1), f = /* @__PURE__ */ o({
  name: "XLg",
  __name: "x-lg",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (t, i) => (r(), a(d, n(l(e.props)), {
      default: p(() => [s(t.$slots, "default"), m]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
